// extracted by mini-css-extract-plugin
export default {"app":"Root_app__89WhN","main":"Root_main__t2gJL","container":"Root_container__qu1pA","card":"Root_card__K2Z21","btn":"Root_btn__IYvlL","btnPrimary":"Root_btnPrimary__njPfk"};